export default __webpack_public_path__ + "static/media/p2.1aa4083a.jpg";